import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { useQueryClient } from 'react-query'

import QueueNumbersAPI from '@api/queueNumbersAPI'

import { ID } from '@models/base'

import { Tooltip } from '@components/Tooltip'

import { QUERIES } from '@/constants/queries'
import { useToast } from '@/hooks'
import AxiosUtil from '@/utils/axiosUtil'

type Props = {
  queueNumberId: ID
}

const QueueNodeCallButton: FC<Props> = ({ queueNumberId }) => {
  const intl = useIntl()
  const toast = useToast()
  const client = useQueryClient()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const callNode = async () => {
    try {
      setIsLoading(true)
      await QueueNumbersAPI.updateStatus('call', { queue_number_id: queueNumberId })
      client.invalidateQueries(QUERIES.QUEUE_NUMBER_CURRENT)
      client.invalidateQueries(QUERIES.QUEUE_PROCESS)
    } catch (err) {
      if (AxiosUtil.isAxiosError(err) && err.response?.data.message) {
        toast.error(err.response.data.message)
      }
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Tooltip
      text={intl.formatMessage({
        id: 'queue_number.call',
      })}
      placement="top"
    >
      <button
        type="button"
        className="btn btn-sm btn-icon btn-secondary"
        onClick={callNode}
        disabled={isLoading}
      >
        <i className="fas fa-bullhorn" />
      </button>
    </Tooltip>
  )
}

export { QueueNodeCallButton }
